
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      openAccordionIndex: this.data.first_accordion_open ? 0 : null,
    }
  },

  methods: {
    evenLinks(links) {
      return links.filter((link, i) => {
        return i % 2 === 0
      })
    },

    oddLinks(links) {
      return links.filter((link, i) => {
        return i % 2 === 1
      })
    },
  },
}
